<script setup lang="ts">
  import { computed } from 'vue';
  import type { MpfAppHeaderProps } from './MpfAppHeader.props';
  import { mpfAppHeaderDefaults } from './MpfAppHeader.defaults';

  const props = withDefaults(defineProps<MpfAppHeaderProps>(), mpfAppHeaderDefaults);

  const showHeader = computed(() => !props.isOpenInNhsApp);

  const showEmptyBrandLogo = computed(
    () => props.isTenantLoaded && !props.tenantId && !props.isNhsWebApp && !props.isLoading,
  );

  const showWebAppBrand = computed(() => props.isNhsWebApp && !props.isLoading);

  const showTenantName = computed(() => !!props.tenantId && !props.isNhsWebApp && !props.isLoading);

  const titleText = computed(() => (!props.isLoading ? props.tenantName || 'NHS England' : null));
</script>

<template>
  <header v-if="showHeader" class="mpf-header" role="banner" data-module="mpf-header">
    <div class="mpf-header__container mpf-width-container">
      <div class="mpf-header__service">
        <h1 class="mpf-header--title mpf-u-margin-top-3 mpf-u-margin-bottom-3 mpf-heading-m">
          <span v-if="showEmptyBrandLogo" class="brand-logo" aria-hidden="true" />

          <span v-if="showWebAppBrand" class="brand-logo" aria-hidden="true" />
          <span v-if="showWebAppBrand" class="nhs-app--title"> App </span>

          <span v-if="showTenantName">
            {{ titleText }}
          </span>
        </h1>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
  // min height stops layout shift whilst waiting for tenant title
  .mpf-header {
    min-height: 77px;
  }

  @media (width >= 40.0625em) {
    .mpf-header {
      min-height: 96px;
    }
  }

  .mpf-header--title {
    display: flex;
    gap: var(--mpf-grid-gap);
    align-items: center;
  }

  .nhs-app--title {
    font-weight: normal;
  }
</style>
